<div class="service--banner" [innerHTML]="'common.serviceBannerInfo' | translate"></div>